var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoctor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "125px",
    height: "142px",
    viewBox: "0 0 125 142",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1A08EE0A-AD09-483B-A180-FCF8444922C2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "7.-suitable-for",
    transform: "translate(-926.000000, -368.000000)",
    strokeWidth: 4.9
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(929.000000, 371.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.44611,135.81211 L119.44611,119.38836 C119.44611,102.96426 106.69281,91.26866 89.58446,87.03821 L79.63046,84.54971 C79.63046,95.54461 70.71771,104.45736 59.72316,104.45736 C48.72826,104.45736 39.81551,95.54461 39.81551,84.54971 L29.86151,87.03821 C12.75351,91.26866 0.00021,102.96426 0.00021,119.38836 L0.00021,135.81211 L119.44611,135.81211 Z",
    id: "Stroke-1",
    stroke: "#222456"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.16517,74.595955 L72.16517,70.940555 C68.21787,73.258955 63.94962,74.595955 59.72302,74.595955 C55.49642,74.595955 51.22817,73.258955 47.28087,70.940555 L47.28087,74.595955 C47.28087,80.093405 43.93837,84.549605 39.81537,84.549605 C39.81537,95.544855 48.72847,135.812005 59.72302,135.812005 C70.71757,135.812005 79.63067,95.544855 79.63067,84.549605 C75.50732,84.549605 72.16517,80.093405 72.16517,74.595955 Z",
    id: "Stroke-3",
    stroke: "#222456",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.26997,87.66898 C24.95367,92.52523 23.77837,97.67758 23.76017,102.97868 C19.25567,103.04903 15.60937,106.72333 15.60937,111.24463 L15.60937,122.10373 L15.74447,122.10373 L15.74447,122.23883 L18.45942,122.23883 L18.45942,121.96828 L15.87992,121.96828 L15.87992,111.24463 C15.87992,106.82833 19.47337,103.23628 23.88862,103.23628 C28.30422,103.23628 31.89767,106.82833 31.89767,111.24463 L31.89767,121.96828 L29.31817,121.96828 L29.31817,122.23883 L32.03277,122.23883 L32.03277,122.10373 L32.16787,122.10373 L32.16787,111.24463 C32.16787,106.72858 28.52927,103.05813 24.03072,102.98008 C24.04857,97.71818 25.21617,92.60783 27.51392,87.78588 C31.31317,79.81428 36.80187,74.60768 44.87567,71.22213 L44.76962,70.97293 C36.63457,74.38508 31.09687,79.63648 27.26997,87.66898 Z",
    id: "Stroke-5",
    stroke: "#ED7330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.17719,87.66898 C88.34889,79.63648 82.81119,74.38228 74.67649,70.97293 L74.57044,71.22213 C82.64424,74.60768 88.13294,79.81428 91.93324,87.78588 C94.24779,92.64528 95.42204,97.79868 95.42204,103.10083 L95.69259,103.10083 C95.69259,97.75633 94.51029,92.56548 92.17719,87.66898 Z",
    id: "Stroke-7",
    stroke: "#ED7330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.343605,109.886805 C102.343605,113.635305 99.304905,116.673655 95.556755,116.673655 C91.808605,116.673655 88.770255,113.635305 88.770255,109.886805 C88.770255,106.138655 91.808605,103.099955 95.556755,103.099955 C99.304905,103.099955 102.343605,106.138655 102.343605,109.886805 Z",
    id: "Stroke-9",
    stroke: "#ED7330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.65381,24.8269 L44.79216,24.8269 C36.58046,24.8269 29.86151,31.5455 29.86151,39.75755 C29.86151,58.99845 45.10331,74.59585 59.72316,74.59585 C74.34266,74.59585 89.58446,58.99845 89.58446,39.75755 C89.58446,31.5455 82.86551,24.8269 74.65381,24.8269 Z",
    id: "Stroke-11",
    stroke: "#222456"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.584495,39.75762 L89.584495,39.75762 C89.584495,31.54557 82.865545,24.82697 74.653845,24.82697 L44.792195,24.82697 C36.580495,24.82697 29.861545,31.54557 29.861545,39.75762 C29.861545,39.75762 23.329495,5.66587 50.079995,3.92357 C57.529745,3.43847 63.547295,-0.00028 71.966545,-0.00028 C80.386145,-0.00028 89.584495,6.75017 89.584495,6.75017 L89.584495,39.75762 Z",
    id: "Stroke-13",
    stroke: "#222456"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctor);
export default __webpack_public_path__ + "static/media/doctor.2a786910.svg";
export { ForwardRef as ReactComponent };